var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sword-layout',[_c('div',{staticClass:"reset loading-wrapper"},[_c('pulse-loader-v2'),(_vm.message)?_c('p',{staticClass:"loading-message"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }